function getRows({ rowNums = 6, rowContainerStyles, rowStyles }) {
  const rows = [];
  for (let i = 0; i < rowNums; i++) {
    rows.push(<RowSkeleton rowContainerStyles={rowContainerStyles} rowStyles={rowStyles} />);
  }

  return rows;
}

const LoadingScreen = ({ rowNums = 6, rowContainerStyles = {}, rowStyles = {} }) => {
  return (
    <div className="tw-flex tw-w-full  tw-animate-pulse tw-flex-col tw-items-center tw-justify-center">
      {getRows({ rowNums, rowContainerStyles, rowStyles })}
    </div>
  );
};

const RowSkeleton = ({ rowContainerStyles, rowStyles }) => 
  <div
    className="tw-w-full tw-border-b tw-border-solid tw-border-[#111C361F] tw-pr-[24px] tw-py-[22.5px] last:tw-border-none"
    style={rowContainerStyles}
  >
    <div className="tw-h-[12px] tw-rounded-full tw-bg-[#E0E0E0]" style={rowStyles} />
  </div>
;
export default LoadingScreen;
